import { inject, Injectable } from '@angular/core';
import { ID_FIELD_OPTIONS, WW_SAVED_SEARCH_COLLECTION } from '@damofire/data-commons';
import { AuthDtoSignerService, AuthenticationService } from '@damofire/data-security';
import { deleteDoc, doc, docData, DocumentReference, Firestore } from '@angular/fire/firestore';
import { firstValueFrom } from 'rxjs';
import { SavedSearchService } from './saved-search.service';
import { SavedSearch } from './saved-search.dto';

@Injectable()
export class FirebaseSavedSearchService extends SavedSearchService {
  private readonly firestore = inject(Firestore);

  constructor(
    private readonly dtoSigner: AuthDtoSignerService,
    protected readonly appAuthService: AuthenticationService,
  ) {
    super();
  }

  async create(create: Partial<SavedSearch>): Promise<SavedSearch> {
    let createdRef: DocumentReference;
    if (create._id) {
      createdRef = await this.dtoSigner.set(create, `${WW_SAVED_SEARCH_COLLECTION}/${create._id}`);
    } else {
      createdRef = await this.dtoSigner.add(create, WW_SAVED_SEARCH_COLLECTION);
    }
    return { ...create, _id: createdRef.id };
  }

  async update(update: SavedSearch): Promise<void> {
    await this.dtoSigner.update<unknown>(update, `${WW_SAVED_SEARCH_COLLECTION}/${update._id}`);
  }

  async get(divisionId: string, id: string): Promise<SavedSearch> {
    return firstValueFrom(docData<SavedSearch>(doc(this.firestore, `${WW_SAVED_SEARCH_COLLECTION}/${id}`), ID_FIELD_OPTIONS));
  }

  async delete(division: string, id: string): Promise<void> {
    return deleteDoc(doc(this.firestore, `${WW_SAVED_SEARCH_COLLECTION}/${id}`));
  }
}
